import { ERROR_MESSAGES as CORE_ERROR_MESSAGES } from '@core/constants';

const ccName = import.meta.env.VITE_APP_CC_NAME;

export enum GROUP_CODE {
  BANK_CODE = 'BANK_CODE', // 은행 코드
  BANNER_LOCATION = 'BANNER_LOCATION', // 배너 위치 (메인, 서브 등)
  CADDIE_FEE_DIV = 'CADDIE_FEE_DIV', // 캐디 피 구분 (기본, 할증 등)
  CADDIE_GRADE = 'CADDIE_GRADE', // 캐디 등급 (프로, 일반 등)
  COURSE_CODE = 'COURSE_CODE', // 골프 코스 코드 (동, 서, 남, 북 코스 등)
  CRTF_CODE = 'CRTF_CODE', // 인증 코드
  DEPOSIT_CARD_STATUS = 'DEPOSIT_CARD_STATUS', // 입금 카드 상태 (입금완료, 입금대기 등)
  DPMNY_STATUS = 'DPMNY_STATUS', // 출금 상태 (출금완료, 출금대기 등)
  HOLE_DIV = 'HOLE_DIV', // 홀 구분 (1~18홀)
  HOPE_TIME_ZONE = 'HOPE_TIME_ZONE', // 희망 시간대 (오전, 오후 등)
  LOTTERY_RCEPT_STATUS = 'LOTTERY_RCEPT_STATUS', // 추첨 접수 상태 (접수중, 마감 등)
  PART_DIV = 'PART_DIV', // 부 구분
  RCEPT_STATUS = 'RCEPT_STATUS', // 접수 상태 (접수완료, 접수대기 등)
  ROOM_TYPE = 'ROOM_TYPE', // 객실 유형 (호텔, 펜션 등)
  SEASON_DIV = 'SEASON_DIV', // 시즌 구분 (성수기, 비수기 등)
  VISIT_PURPS = 'VISIT_PURPS', // 방문 목적 (라운딩, 연습 등)
  PENLTY_CODE = 'PENLTY_CODE', // 위약 코드
}

export enum ERROR_MESSAGES_RESERVATION {
  UNOPENED = '오픈전입니다.',
  END = '마감되었습니다.',
  PAST = '마감되었습니다.',
  CLOSE = '휴장입니다.',
}

export enum BOARD_TYPE {
  NEWS = 'news',
  EVENT = 'event',
  JOIN = 'join',
  ARCHIVE = 'archive',
}

export const ERROR_MESSAGES: { [key: string]: string } = {
  ...CORE_ERROR_MESSAGES,
  INTERCEPTED_ID: `회원님은 홈페이지 사용이 제한된 상태입니다.<br />
홈페이지 사용을 원하시면<br /> ${ccName}로 연락주시기 바랍니다.`,
  FIND_ID_DUPLICATED_WEB_ID: `아이디가 2건 이상 조회되었습니다.<br />${ccName}로 연락주시기 바랍니다.`,
  NOT_EXIST_MEMBER: `입력하신 회원번호의 회원이 존재하지 않습니다.<br />${ccName}로 연락주시기 바랍니다.`,
  FIND_ID_DUPLICATED_MEMBER: `회원정보가 2건 이상 조회되었습니다.<br />${ccName}로 연락주시기 바랍니다.`,
  FIND_ID_DUPLICATED_MEMBERSHIP: `회원권정보가 2건 이상 조회되었습니다.<br />${ccName}로 연락주시기 바랍니다.`,
  PASSWORD_MISMATCH: '현재 비밀번호가 일치하지 않습니다.',
  CHANGE_PASSWORD:
    '홈페이지 개편으로 인해<br />비밀번호 재설정 화면으로<br />이동합니다.',
  PASSWORD_NOT_AVAILABLE:
    '회원번호 뒷 네자리는<br />사용 불가능한 비밀번호입니다.',
  ID_OR_MEMBER_NO_DUPLICATED: '이미 존재하는 아이디입니다.',
  RESERVATION_DATE_EXPIRED: '예약가능일자가 만료되었습니다.',
};

export enum ROUTE_NAME {
  Main = 'Main', // 메인

  RepairHomepage = 'RepairHomepage', //홈페이지 점검
  NotFound = 'NotFound', //잘못된 URL 페이지

  // mypage
  CancellationHistory = 'CancellationHistory', //취소내역
  NewPasswordAccount = 'NewPasswordAccount', //비밀번호변경
  NewIDAccount = 'NewIDAccount', //아이디변경
  PenaltyHistory = 'PenaltyHistory', //위약내역

  //클럽소개 club-info
  GolfClubNetwork = 'GolfClubNetwork',
  InteractionClub = 'InteractionClub',
  Introduction = 'Introduction',
  Location = 'Location', //오시는 길
  Overview = 'Overview',

  //운영안내 use-information
  UserGuide = 'UserGuide', //이용안내
  FeeInfo = 'FeeInfo', //요금안내
  MatchInfo = 'MatchInfo', //경기안내
  PrivacyPolicy = 'PrivacyPolicy', //개인정보보호책임
  ResourceLibrary = 'ResourceLibrary',

  //코스안내 course-information
  // CourseInformation = 'CourseInformation',
  CourseFeatures = 'CourseFeatures', //코스특징
  CourseTips = 'CourseTips', //코스공략
  WestCourse = 'WestCourse',
  EastCourse = 'EastCourse',

  // 예약 reservation
  Reservation = 'Reservation', // 예약하기
  ReservationTimeList = 'ReservationTimeList', // 예약타임리스트
  ReservationStatus = 'ReservationStatus', // 예약내역확인/취소
  ReservationWaitStatus = 'ReservationWaitStatus', // 대기예약
  ReservationLotteryStatus = 'ReservationLotteryStatus', // 추첨예약

  // 시설안내 facility
  ClubHouse = 'ClubHouse', // 클럽하우스
  LockerRoom = 'LockerRoom', // 로커룸
  HalfwayHouse = 'HalfwayHouse', // 그늘집
  EventHall = 'EventHall', // 연회장
  DiningInfo = 'DiningInfo',
  ProShop = 'ProShop',

  // 커뮤니티 community
  // Community = 'Community',
  News = 'News', // 송추소식
  NewsView = 'NewsView',
  NewsWrite = 'NewsWrite',
  NewsModify = 'NewsModify',
  RelatedSites = 'RelatedSites', //관련사이트

  //main
  SignIn = 'SignIn', //로그인
  SignInAdmin = 'SignInAdmin', //관리자 로그인
  SiteMap = 'Sitemap',
  Weather = 'Weather',
  FindPassword = 'FindPassword',
}
